<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,500,600,700,800,900|Poppins:300,400,500,600,700,700i&display=swap");
</style>

<template>
    <v-app>
        <app-drawer></app-drawer>
        <app-header></app-header>
        <v-main style="overflow:hidden;position:relative;" id="main">
            <app-auth-overlay v-model="overlay.show"></app-auth-overlay>
            <router-view></router-view>
            <app-snackbar></app-snackbar>
            <app-dialog v-model="dialog.show" :config="dialog.config"></app-dialog>
        </v-main>
        <app-bottom-sheet></app-bottom-sheet>
        <!--<app-footer></app-footer>-->
    </v-app>
</template>

<script>
import appDrawer from "./components/app.drawer.vue";
import appHeader from "./components/app.header.vue";
import appAuthOverlay from "./components/app.auth.overlay.vue";
//import appFooter from "./components/app.footer.vue";
import appBottomSheet from "./components/app.bottom.sheet.vue";
import appDialog from "./components/app.dialog.vue";
import appSnackbar from "./components/app.snackbar.vue";

import events from "./app.events";

export default { 
    data: function () {
        return {
            dialog: {
                show: false,
                config: {
                    onConfirm: null,
                    onCancel: null
                }
            },
            overlay: {
                show: false
            }
        }
    },
    mounted: function () {
    },
    created: function () {
        this.$bus.handle(events.APP_DIALOG_OPEN, this.dialogOpen.bind(this));
        this.$bus.handle(events.APP_AUTH_SHOW, this.authShow.bind(this));
    },
    computed: {
    },
    methods: {
        dialogOpen(config) {
            this.$set(this.dialog, "config", config);
            this.dialog.show = true;
        },
        authShow(show) {
            this.overlay.show = show;
        }        
    },
    components: {
    appDrawer,
    appHeader,
    appAuthOverlay,
//    appFooter,
    appBottomSheet,
    appDialog,
    appSnackbar
}
}
</script>
